module.exports = __webpack_public_path__ + "img/关于我们—专题研究.2d731b11.jpg";